export default __webpack_public_path__ + "static/perspective-1050aa67594f4dd177c32fa18d73752e.jpg";